// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dialog-dialog .el-dialog__body {\n  -webkit-user-select: auto !important;\n     -moz-user-select: auto !important;\n      -ms-user-select: auto !important;\n          user-select: auto !important;\n  border-radius: 14px !important;\n  font-size: 20px !important;\n  padding: 15px;\n}\n.dialog-dialog .el-alert__title {\n  font-size: 20px !important;\n}\n", ""]);
// Exports
module.exports = exports;
